import React, { useEffect, useState } from 'react';
import { Flag, Loader2, Check } from 'lucide-react';
import { community as commApi } from '../services/api';
import { toast } from '../hooks/use-toast';

const FILTERS = [['open', 'Open'], ['handled', 'Handled'], ['all', 'All']];

export default function AdminCommunityReportsPanel() {
  const [status, setStatus] = useState('open');
  const [items, setItems] = useState(null);
  const load = () => { setItems(null); commApi.adminReports(status).then(setItems).catch(() => setItems([])); };
  useEffect(load, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  const resolve = async (id) => {
    try { await commApi.adminResolve(id); toast({ title: 'Marked as handled' }); load(); }
    catch { toast({ title: 'Could not update report' }); }
  };

  return (
    <div className="space-y-4" data-testid="admin-community-reports">
      <div className="flex items-center gap-2">
        <Flag size={18} className="text-red-400" />
        <h2 className="text-lg font-semibold text-white">Community reports</h2>
        <div className="ml-auto flex gap-1">
          {FILTERS.map(([k, l]) => (
            <button key={k} onClick={() => setStatus(k)} data-testid={`community-reports-filter-${k}`}
              className={`px-3 py-1 rounded-full text-xs font-semibold border ${status === k ? 'bg-green-500 text-black border-green-500' : 'border-[#2a2a2a] text-gray-200'}`}>{l}</button>
          ))}
        </div>
      </div>
      {items === null ? <Loader2 className="animate-spin text-gray-400" size={18} />
        : items.length === 0 ? <div className="pbb-card p-8 text-center text-sm text-gray-300" data-testid="community-reports-empty">No {status === 'all' ? '' : status} reports.</div>
        : items.map(r => (
          <div key={r.id} className="pbb-card p-4 space-y-2" data-testid={`community-report-${r.id}`}>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <span className="font-semibold text-white">{r.reportedName}</span>
              <span className="text-gray-400">({r.reportedEmail})</span>
              <span className="text-gray-300">reported by</span>
              <span className="font-semibold text-white">{r.reporterName}</span>
              <span className="ml-auto text-xs text-gray-400">{new Date(r.createdAt).toLocaleString()}</span>
            </div>
            <div className="flex flex-wrap gap-2 text-xs">
              <span className="px-2 py-0.5 rounded bg-red-500/15 text-red-300 border border-red-500/30">{r.reason}</span>
              <span className="px-2 py-0.5 rounded bg-white/10 text-gray-200">About: {r.kind}</span>
              {r.blocked && <span className="px-2 py-0.5 rounded bg-white/10 text-gray-200">Reporter also blocked them</span>}
              <span className={`px-2 py-0.5 rounded ${r.status === 'open' ? 'bg-yellow-500/15 text-yellow-300' : 'bg-green-500/15 text-green-300'}`}>{r.status === 'open' ? 'Open' : `Handled${r.handledBy ? ` by ${r.handledBy}` : ''}`}</span>
            </div>
            {r.content && <div className="text-sm text-gray-100 bg-black/40 border border-[#1f1f1f] rounded-lg p-3 whitespace-pre-wrap">"{r.content}"</div>}
            {r.details && <div className="text-sm text-gray-300">Reporter's note: {r.details}</div>}
            {r.status === 'open' && (
              <button onClick={() => resolve(r.id)} data-testid={`community-report-resolve-${r.id}`}
                className="px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-700 text-white text-xs font-semibold inline-flex items-center gap-1"><Check size={12} /> Mark handled</button>
            )}
          </div>
        ))}
    </div>
  );
}
